const signature = {
  "id": "signature",
  "title": "Signature",
  "description": {
    "en": "Signature - a unique home at a unique address. This modern building with an exclusive location at \"Cherni Vrah\" Blvd. No. 65 combines style, architecture and quality to provide you with the luxury of our fast-paced daily life - time and space. The project offers us a picturesque view of Vitosha and hassle-free access to numerous amenities. Signature is our signature, unfading over time.\n\nThe execution and materials in Signature are of guaranteed quality. The building will be executed with Schüco aluminum joinery - a global leader in the field of construction, known for their quality and innovative solutions for energy efficiency and acceptable noise levels. We also trust the Austrian company Wienerberger, the world's largest brick manufacturer, preferred by architects, engineers and builders worldwide. The suspended ventilated facade creates conditions for natural ventilation of the building, eliminates condensation between walls and reduces moisture levels, allowing the building to \"breathe\".",
    "bg": "Signature - неповторим дом на неповторим адрес. Тази модерна сграда с ексклузивна локация на бул. \"Черни връх\" № 65 съчетава стил, архитектура и качество, за да ви предостави луксът на нашето забързано ежедневие - време и пространство. Проектът ни предлага живописната гледка на Витоша и безпроблемен достъп до множество удобства. Signature е нашият подпис, неизбледняващ във времето.\n\nИзпълнението и материалите в Signature са с гарантирано качество. Сградата ще бъде изпълнена с алуминиева дограма Schüco - глобален лидер в областта на строителството, известни със своите качествени и иновативни решения за енергийна ефективност и допустими нива на шум. Доверяваме се и на Австрийската фирма Wienerberger най-големият производител на тухли в света, предпочитан от архитекти, инженери и строители по цял свят. Окачената вентилируема фасада създава условия за естествена вентилация на сградата, елиминира конденза между стените и понижава нивата на влага, позволявайки на сградата да \"диша\".",
    "de": "Signature - ein einzigartiges Zuhause an einer einzigartigen Adresse. Dieses moderne Gebäude mit exklusiver Lage am \"Cherni Vrah\" Blvd. Nr. 65 vereint Stil, Architektur und Qualität, um Ihnen den Luxus unseres hektischen Alltags zu bieten - Zeit und Raum. Das Projekt bietet uns einen malerischen Blick auf Vitosha und problemlosen Zugang zu zahlreichen Annehmlichkeiten. Signature ist unsere Unterschrift, die mit der Zeit nicht verblasst.\n\nDie Ausführung und Materialien in Signature sind von garantierter Qualität. Das Gebäude wird mit Schüco-Aluminiumfenstern ausgeführt - ein globaler Marktführer im Bauwesen, bekannt für ihre qualitativ hochwertigen und innovativen Lösungen für Energieeffizienz und akzeptable Geräuschpegel. Wir vertrauen auch der österreichischen Firma Wienerberger, dem weltweit größten Ziegelhersteller, der von Architekten, Ingenieuren und Bauherren weltweit bevorzugt wird. Die vorgehängte hinterlüftete Fassade schafft Bedingungen für die natürliche Belüftung des Gebäudes, eliminiert Kondensation zwischen den Wänden und reduziert die Feuchtigkeitswerte, sodass das Gebäude \"atmen\" kann.",
    "ru": "Signature - уникальный дом по уникальному адресу. Это современное здание с эксклюзивным расположением на бул. \"Черни връх\" № 65 сочетает стиль, архитектуру и качество, чтобы предоставить вам роскошь нашей стремительной повседневной жизни - время и пространство. Проект предлагает нам живописный вид на Витошу и беспроблемный доступ к многочисленным удобствам. Signature - это наша подпись, не тускнеющая со временем.\n\nИсполнение и материалы в Signature имеют гарантированное качество. Здание будет выполнено с алюминиевыми окнами Schüco - глобальным лидером в области строительства, известным своими качественными и инновационными решениями для энергоэффективности и приемлемых уровней шума. Мы также доверяем австрийской компании Wienerberger, крупнейшему в мире производителю кирпича, предпочитаемому архитекторами, инженерами и строителями по всему миру. Навесной вентилируемый фасад создает условия для естественной вентиляции здания, устраняет конденсацию между стенами и снижает уровень влажности, позволяя зданию \"дышать\"."
  },
  "location": {
    "en": "Sofia, Cherni Vrah Blvd. 65",
    "bg": "София, бул. Черни връх № 65",
    "de": "Sofia, Cherni Vrah Blvd. 65",
    "ru": "София, бул. Черни връх № 65"
  },
  "mapData": {
    "embedUrl": "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2933.5!2d23.316017!3d42.653364!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x40aa8682c0c0c0c1%3A0x0!2z0JHRg9C70LXQs9C40Y8g0JHRg9C70LXQs9C40Y8!5e0!3m2!1sen!2sbg!4v1759425150348!5m2!1sen!2sbg",
    "directionsUrl": "https://maps.app.goo.gl/LVhdr1LfjVdztJqb9",
    "coordinates": {
      "lat": 42.652169,
      "lng": 23.316538
    }
  },
  "type": "Residential Complex",
  "year": "2025",
  "status": "Act 14",
  "heroImage": "/projects/Signature/signature.png",
  "images": [
    "/projects/Signature/signature.png",
    "/projects/Signature/signature1.jpg",
    "/projects/Signature/4_159.jpg",
    "/projects/Signature/CAM 2.jpg",
    "/projects/Signature/Cam2.jpg",
    "/projects/Signature/detska 01_Interactive LightMix.jpg",
    "/projects/Signature/east.jpg",
    "/projects/Signature/livingroom cam 01_Interactive LightMix.jpg",
    "/projects/Signature/livingroom cam 02_Interactive LightMix.jpg",
    "/projects/Signature/livingroom cam 03_Interactive LightMix.jpg",
    "/projects/Signature/livingroom cam 04_Interactive LightMix.jpg"
  ],
  "features": {
    "en": [
      "Location",
      "Picturesque view of Vitosha",
      "Highest class materials",
      "Modern architecture",
      "French windows",
      "High ceilings",
      "Proper apartment forms",
      "High added value"
    ],
    "bg": [
      "Локация",
      "Живописна гледка към Витоша",
      "Най-висок клас материали",
      "Модерна архитектура",
      "Френски прозорци",
      "Високи тавани",
      "Правилни форми на апартаментите",
      "Висока добавена стойност"
    ],
    "de": [
      "Lage",
      "Malerischer Blick auf Vitosha",
      "Materialien höchster Klasse",
      "Moderne Architektur",
      "Französische Fenster",
      "Hohe Decken",
      "Richtige Wohnungsformen",
      "Hoher Mehrwert"
    ],
    "ru": [
      "Местоположение",
      "Живописный вид на Витошу",
      "Материалы высшего класса",
      "Современная архитектура",
      "Французские окна",
      "Высокие потолки",
      "Правильные формы квартир",
      "Высокая добавленная стоимость"
    ]
  },
  "stats": {
    "area": "N/A",
    "floors": "N/A",
    "units": "N/A"
  },
  "availableApartments": 13
};

export default signature;
